import { useEffect, useState, useContext } from "react";
import API from "../api/api";
import { UserContext } from "../context/UserContext";
import { Fase, PUNTOS_CAMPEON } from "../shared/multiplicadores";
import { useNavigate } from "react-router-dom";
import { AlertContext } from "../context/AlertContext";
import "../css/Campeones.css";
import Bandera from "./components/Banderas";

type Posicion = "campeon" | "subcampeon" | "tercer_puesto";

interface Seleccion {
  id: number;
  nombre: string;
  grupo: string;
  bandera: string;
}

const Campeones = () => {
  const userCtx = useContext(UserContext);
  const user = userCtx?.user;

  const [faseActual, setFaseActual] = useState<Fase | null>(null);
  const [selecciones, setSelecciones] = useState<Seleccion[]>([]);
  type PodioData = {
  seleccion_id: number | null;
  puntos_posibles: number | null;
};

const navigate = useNavigate();
const alertCtx = useContext(AlertContext);
const showAlert = alertCtx?.showAlert ?? (() => {});

const requireLogin = (action: () => void) => {
  if (!user) {
    showAlert("Iniciá sesión para predecir el podio 🏆", "info");
    navigate("/login");
    return;
  }
  action();};



const [podio, setPodio] = useState<Record<Posicion, PodioData>>({
  campeon: { seleccion_id: null, puntos_posibles: null },
  subcampeon: { seleccion_id: null, puntos_posibles: null },
  tercer_puesto: { seleccion_id: null, puntos_posibles: null },
});

const [podioEdit, setPodioEdit] = useState<Record<Posicion, PodioData>>({
  campeon: { seleccion_id: null, puntos_posibles: null },
  subcampeon: { seleccion_id: null, puntos_posibles: null },
  tercer_puesto: { seleccion_id: null, puntos_posibles: null },
});

  // 🔹 estado edición
  const [editando, setEditando] = useState<Record<Posicion, boolean>>({
    campeon: false,
    subcampeon: false,
    tercer_puesto: false,
  });

  const [modal, setModal] = useState<{
  visible: boolean;
  mensaje: string;
  onConfirm?: () => void;
}>({
  visible: false,
  mensaje: ""
});

  // 🔹 toast simple
  const [toast, setToast] = useState<string | null>(null);

  // 🔹 fase actual
  useEffect(() => {
    API.get("/torneo/fase").then(res => {
      setFaseActual(res.data.fase);
    });
  }, []);

  // 🔹 selecciones
  useEffect(() => {
    API.get("/selecciones").then(res => {
  if (Array.isArray(res.data)) {
    setSelecciones(res.data);
  } else {
    console.warn("⚠️ /selecciones no devolvió array:", res.data);
    setSelecciones([]);
  }
});
  }, []);

useEffect(() => {
  if (!user) return;

 API.get(`/podio/${user.id}`).then(res => {
  console.log("PODIO RESPONSE:", res.data);

  if (!Array.isArray(res.data)) {
    console.warn("⚠️ podio no es array:", res.data);
    return;
  }
  setPodio(prev => {
    const nuevo = { ...prev };
    res.data.forEach((p: any) => {
      nuevo[p.posicion as Posicion] = {
        seleccion_id: p.seleccion_id,
        puntos_posibles: p.puntos_posibles
      };
    });
    return nuevo;
  });
});

}, [user]);


  if (!faseActual) return null;

  const seleccionPorId = (id: number | null) =>
    selecciones.find(s => s.id === id);

 const guardar = async (posicion: Posicion) => {
  if (!user || !podioEdit[posicion].seleccion_id) return;

  try {
    const res = await API.post("/podio/campeones", {
      id_usuario: user.id,
      posicion,
      seleccion_id: podioEdit[posicion].seleccion_id,
    });

    setPodio((prev) => ({
      ...prev,
      [posicion]: {
        seleccion_id: podioEdit[posicion].seleccion_id,
        puntos_posibles: res.data.puntos_posibles
      }
    }));

    setToast(
      `Predicción actualizada. Máximo posible: ${res.data.puntos_posibles} pts`
    );

    setTimeout(() => setToast(null), 3000);

  } catch (err) {
    console.error(err);
    setToast("Error al guardar predicción");
  }
};



const confirmarCambio = async (posicion: Posicion) => {
  if (!user) return;

  const res = await API.get(`/podio/preview/${user.id}/${posicion}`);

  // 🔹 Primera vez → guarda directo
  if (!res.data.existe) {
    await guardar(posicion);
    setEditando(prev => ({ ...prev, [posicion]: false }));
    return;
  }

  const { puntos_actuales, puntos_nuevos } = res.data;

  const mensaje =
    puntos_nuevos < puntos_actuales
      ? `⚠️ Estás cambiando tu predicción.\n\nAntes: ${puntos_actuales} pts\nAhora: ${puntos_nuevos} pts\n\n¿Querés continuar?`
      : `ℹ️ Estás cambiando tu predicción.\n\nTus puntos posibles quedarán fijados en ${puntos_nuevos} pts según la fase actual.\n\n¿Querés continuar?`;

  setModal({
    visible: true,
    mensaje,
    onConfirm: async () => {
      await guardar(posicion);
      setEditando(prev => ({ ...prev, [posicion]: false }));
      setModal({ visible: false, mensaje: "" });
    }
  });
};



function getBadgeType(clase: string): string {
  if (clase.includes("inicial"))   return "inicial";
  if (clase.includes("esperando")) return "esperando";
  if (clase.includes("acierto"))   return "acierto";
  return "fallo";
}

function getBadgeText(clase: string, fase?: Fase | null): string {
  if (clase.includes("inicial"))   return "Aún no elegido";
  if (clase.includes("esperando")) return fase === "final" ? "Resultado pendiente" : "Esperando Resultados";
  if (clase.includes("acierto"))   return "¡Acierto!";
  return "Falló";
}

const getEstado = (pos: Posicion): string => {
  const data = podio[pos];

  if (!data.seleccion_id) return `estado-inicial-${pos}`;

  if (faseActual !== "final")
  return `estado-esperando-${pos}`;

  

  // Cuando tengas resultado real:
  const acerto = false; // acá irá tu lógica real

  return acerto
    ? `estado-acierto-${pos} estado-acierto`
    : `estado-fallo-${pos} estado-fallo`;
};


return (
  <div className="campeones-grid">
    {(["subcampeon", "campeon", "tercer_puesto"] as Posicion[]).map((pos) => {
      const seleccion = seleccionPorId(podio[pos].seleccion_id);
      const estadoClase = getEstado(pos);
      const puntos = podio[pos].puntos_posibles;
      
          let videoSrc: string | null = null;

          if (estadoClase.includes("esperando")) {
            videoSrc = "/estados3/esperando2.webm";
          } else if (estadoClase.includes("acierto")) {

            switch (pos) {
              case "campeon":
                videoSrc = "/estados3/acierto-campeon.webm";
                break;
              case "subcampeon":
                videoSrc = "/estados3/acierto-subcampeon.webm";
                break;
              case "tercer_puesto":
                videoSrc = "/estados3/acierto-tercer.webm";
                break;
            }
          }



          return (
            <div key={pos} className={`card-podio ${estadoClase}`}>

                {videoSrc && (
                    <video
                      key={videoSrc} // 🔥 fuerza recarga si cambia
                      className="card-video2"
                      autoPlay
                      loop
                      muted
                      playsInline
                      preload="auto"
                    >
                      <source src={videoSrc} type="video/webm" />
                    </video>
                  )}


          {/* Overlay que centra el contenido */}
          <div className="card-overlay">
            <div id="card-overlay-inner">

              {/* Header: título + badge */}
              <div className="card-header">
                <span className="card-title">
                  {pos === "campeon"
                    ? "Campeón"
                    : pos === "subcampeon"
                    ? "Subcampeón"
                    : "Tercer puesto"}
                </span>

                <span className={`badge-estado badge-${getBadgeType(estadoClase)}`}>
                  {getBadgeText(estadoClase, faseActual)}
                </span>
              </div>

              {/* Modo visualización */}
              {!editando[pos] ? (
                <>
                  {/* Selección elegida */}
                  {seleccion && (
                    <div className="card-info">
                      <Bandera
                        grupo={seleccion.grupo}
                        nombre={seleccion.bandera}
                        alt={seleccion.nombre}
                        size={64}
                      />
                      <span className="seleccion-nombre">{seleccion.nombre}</span>
                    </div>
                  )}

                  {/* Puntos posibles */}
                 <div className="puntos-container">
                    <div className="puntos-label">
                      {podio[pos].seleccion_id
                        ? "Puntos si aciertas ahora"
                        : "Puntos máximos posibles al inicio"}
                    </div>

                    <div className="puntos-posibles">
                      {puntos !== null
                        ? `${puntos.toLocaleString()} pts`
                        : "2000 pts"}
                    </div>

                    {!podio[pos].seleccion_id && (
                      <div className="puntos-nota">
                        Mientras más tarde elijas, menos puntos recibirás
                      </div>
                    )}
                  </div>

                  {/* Botón principal */}
                  <div className="card-actions">
                    <button
                        className="card-btn card-btn-primary"
                        onClick={() =>
                          requireLogin(() => {
                            setPodioEdit(structuredClone(podio));
                            setEditando((prev) => ({ ...prev, [pos]: true }));
                          })
                        }
                      >
                      {seleccion ? "Cambiar predicción" : "Elegir selección"}
                    </button>
                    {!user && (
                        <div className="puntos-nota">
                          🔒 Iniciá sesión para poder participar
                        </div>
                      )}
                  </div>
                </>
              ) : (
                /* Modo edición */
                <div className="card-edit">
                  <select
                    value={podioEdit[pos].seleccion_id ?? ""}
                    onChange={async (e) => {
                      const seleccionId = Number(e.target.value);

                      setPodioEdit((prev) => ({
                        ...prev,
                        [pos]: {
                          ...prev[pos],
                          seleccion_id: seleccionId || null,
                        },
                      }));

                      if (user && seleccionId) {
                        try {
                          const res = await API.get(
                            `/podio/preview/${user.id}/${pos}`
                          );

                          const puntos = res.data.existe
                            ? res.data.puntos_nuevos
                            : PUNTOS_CAMPEON[faseActual!];

                          setPodioEdit((prev) => ({
                            ...prev,
                            [pos]: {
                              ...prev[pos],
                              puntos_posibles: puntos,
                            },
                          }));
                        } catch (err) {
                          console.error("Error al obtener preview", err);
                        }
                      }
                    }}
                  >
                    <option value="">— Selecciona una selección —</option>
                    {selecciones.map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.nombre} ({s.grupo})
                      </option>
                    ))}
                  </select>

                 <div className="card-actions">
                    <button
                      className="card-btn card-btn-primary"
                      disabled={!podioEdit[pos].seleccion_id}
                      onClick={() => requireLogin(() => confirmarCambio(pos))}
                    >
                      Guardar predicción
                    </button>

                    <button
                      className="card-btn card-btn-secondary"
                      onClick={() => setEditando((prev) => ({ ...prev, [pos]: false }))}
                    >
                      Cancelar
                    </button>
                  </div>

                  {podio[pos].puntos_posibles != null && (
                    <div className="puntos-actuales">
                      Puntos posibles actuales:{" "}
                      <strong>{podio[pos].puntos_posibles} pts</strong>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      );
    })}

    {/* Modal de confirmación */}
    {modal.visible && (
      <div className="modal-backdrop">
        <div className="modal">
          <p style={{ whiteSpace: "pre-line" }}>{modal.mensaje}</p>
         
            <div className="modal-actions">
              <button
                className="card-btn card-btn-primary"
                onClick={modal.onConfirm}
              >
                Confirmar
              </button>

              <button
                className="card-btn card-btn-secondary"
                onClick={() => setModal({ visible: false, mensaje: "" })}
              >
                Cancelar
              </button>
            </div>
        </div>
      </div>
    )}

    {/* Toast */}
    {toast && <div className="toast">{toast}</div>}
  </div>
);

};

export default Campeones;
